import { Stack } from '@chakra-ui/react'
import {
  DatingIcon,
  FriendsIcon,
  ProfessionalIcon
} from 'assets/icons'
import { SingleButton } from 'common/Buttons'
import { LoadingSpinier } from 'common/Loading'
import { isAuth } from 'utils/helpers'

import { ProfilesSection } from 'components/UserSection/MyProfiles/ProfilesSection'
import { EventSection } from './EventSection'

export const MyProfiles = ({
  handleSelectUser,
  handleLogOut,
  isLoading,
  user,
  userProfile
}) => {
  let Friends = []
  let Dating = []
  let Professional = []

  if (userProfile) {
    userProfile.forEach((item) => {
      if (item.profile_type === 'friends') {
        Friends.push(item)
      }

      if (item.profile_type === 'dating') {
        Dating.push(item)
      }

      if (item.profile_type === 'professional') {
        Professional.push(item)
      }
    })
  }

  if (
    isLoading
    || !isAuth()
    || !user
  ) {
    return (
      <Stack
        position="absolute"
        height="100%"
        width="100%"
      >
        <LoadingSpinier />
      </Stack>
    )
  }

  return (
    <Stack
      width="100%"
      spacing="1em"
      direction="column"
      backgroundColor="#c2c3c5"
      p="24px 15px"
    >
      <ProfilesSection
        icon={<FriendsIcon />}
        array={Friends}
        title="Personal"
        handleSelectUser={handleSelectUser}
      />
      <ProfilesSection
        icon={<DatingIcon />}
        array={Dating}
        title="Dating"
        handleSelectUser={handleSelectUser}
        isPending
      />
      <ProfilesSection
        icon={<ProfessionalIcon />}
        array={Professional}
        title="Professional"
        handleSelectUser={handleSelectUser}
        isPending
      />
      <EventSection isPending />

      <Stack alignItems="center">
        <Stack width="75%">
          <SingleButton
            name="log-out"
            click={handleLogOut}
            isLoading={isLoading}
            text="Log Out"
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
